import { useState } from 'react';
import { Link } from 'react-router-dom';
import { adaImages } from '../assets';
import './AtosDaDetail.css';

const outcomes = [
  { num: '50', label: 'Jeunes formés', sub: 'Développeurs Full-Stack certifiés' },
  { num: '85%', label: 'Taux d\'insertion', sub: 'Emploi dans les 3 mois' },
  { num: '12', label: 'Semaines', sub: 'De formation intensive' },
  { num: '1ère', label: 'Cohorte', sub: 'Programme pilote en CI' },
];

const modules = [
  { title: 'HTML, CSS & Design Web', desc: 'Maîtrise des fondamentaux du développement front-end, maquettes et responsive design.' },
  { title: 'JavaScript & React', desc: 'Développement d\'interfaces modernes, composants, hooks et gestion d\'état.' },
  { title: 'Back-end Node.js', desc: 'API REST, bases de données relationnelles et non relationnelles, authentification.' },
  { title: 'Déploiement & DevOps', desc: 'Git, CI/CD, hébergement cloud et bonnes pratiques de livraison de code.' },
];

export default function AtosDaDetail() {
  const [slide, setSlide] = useState(0);
  const total = adaImages.length;
  const prevIdx = (slide - 1 + total) % total;
  const nextIdx = (slide + 1) % total;
  const goPrev = () => setSlide(prevIdx);
  const goNext = () => setSlide(nextIdx);

  return (
    <main className="ada-page">

      {/* HERO */}
      <section className="ada-hero">
        <div className="ada-hero__bg" />
        <div className="ada-hero__grid" />
        <div className="ada-hero__inner">
          <div className="ada-hero__left">
            <div className="ada-hero__badge">
              <span className="ada-hero__badge-dot" />
              <span>Programme complété · 2023</span>
            </div>
            <h1 className="ada-hero__h1">
              Atos<br /><span className="grad-text">Digital Academy</span>
            </h1>
            <p className="ada-hero__sub">
              La première cohorte de référence en développement web fullstack en Côte d'Ivoire. Un programme co-financé par Atos CI, porté par TTA.
            </p>
            <div className="ada-hero__ctas">
              <Link to="/contact" className="btn-primary" style={{ fontSize: '14px', padding: '13px 26px' }}>
                Lancer un programme similaire →
              </Link>
              <Link to="/projets" style={{ fontFamily: "'Sora',sans-serif", fontSize: '14px', fontWeight: 500, padding: '13px 22px', background: 'transparent', border: '1px solid rgba(255,255,255,.2)', color: 'rgba(255,255,255,.75)', borderRadius: '9px', textDecoration: 'none' }}>
                ← Tous les projets
              </Link>
            </div>
            <div className="ada-hero__stats">
              {outcomes.map((o, i) => (
                <div key={i} className="ada-hero__stat-group">
                  {i > 0 && <div className="ada-hero__stat-divider" />}
                  <div className="ada-hero__stat">
                    <span className="grad-text" style={{ fontFamily: "'Sora',sans-serif", fontSize: '26px', fontWeight: 800 }}>{o.num}</span>
                    <span style={{ fontSize: '11px', color: 'rgba(255,255,255,.5)' }}>{o.label}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Hero right: metrics panel, no images */}
          <div className="ada-hero__right">
            <div className="ada-hero__metrics">
              <div className="ada-hero__metrics-header">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8BC53F" strokeWidth="2" strokeLinecap="round">
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
                </svg>
                <span>Résultats du programme</span>
              </div>
              <div className="ada-hero__metrics-grid">
                {outcomes.map((o, i) => (
                  <div key={i} className="ada-hero__metric-card">
                    <div className="ada-hero__metric-num">{o.num}</div>
                    <div className="ada-hero__metric-label">{o.label}</div>
                    <div className="ada-hero__metric-sub">{o.sub}</div>
                  </div>
                ))}
              </div>
              <div className="ada-hero__metrics-footer">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8BC53F" strokeWidth="2" strokeLinecap="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                <span>Objectifs atteints · Abidjan 2023</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* À PROPOS */}
      <section className="section">
        <div className="ada-about">
          <div className="ada-about__text">
            <div className="section-eyebrow">Le programme</div>
            <h2 className="section-title" style={{ fontSize: '32px' }}>
              Formation intensive<br />en développement web
            </h2>
            <p style={{ color: '#555', lineHeight: 1.75, marginBottom: '20px' }}>
              L'ATOS Digital Academy Côte d'Ivoire est la première cohorte pilote lancée par TTA en partenariat avec Atos CI. Ce programme de 12 semaines a formé 50 jeunes talents au développement web fullstack, du front-end à la mise en production.
            </p>
            <p style={{ color: '#555', lineHeight: 1.75, marginBottom: '24px' }}>
              Fort de ce premier succès, ce programme a démontré l'efficacité du modèle pédagogique TTA : formation intensive, projets concrets, insertion professionnelle accompagnée. Il est devenu la référence pour tous nos programmes suivants.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                'Sélection rigoureuse sur dossier et tests',
                'Formation 5 jours/semaine, en présentiel à Abidjan',
                'Projets réels livrés à des entreprises partenaires',
                'Certification internationale reconnue par les recruteurs',
                'Accompagnement carrière de 8 semaines post-formation',
              ].map(item => (
                <div key={item} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--mid)" strokeWidth="2.5" strokeLinecap="round" style={{ flexShrink: 0 }}>
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span style={{ color: '#333' }}>{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="ada-about__images">
            <img src={adaImages[3]} alt="Formation ADA" className="ada-about__img ada-about__img--top" />
            <img src={adaImages[4]} alt="Formation ADA" className="ada-about__img ada-about__img--bottom" />
          </div>
        </div>
      </section>

      {/* MODULES */}
      <section className="section section-alt">
        <div className="section-eyebrow">Curriculum</div>
        <h2 className="section-title">Programme de formation</h2>
        <p className="section-subtitle">Un cursus intensif couvrant l'ensemble de la chaîne de développement web moderne.</p>
        <div className="ada-modules">
          {modules.map((m, i) => (
            <div key={i} className="ada-module-card">
              <div className="ada-module-card__num">{String(i + 1).padStart(2, '0')}</div>
              <div className="ada-module-card__title">{m.title}</div>
              <div className="ada-module-card__desc">{m.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* RÉSULTATS */}
      <section className="section">
        <div className="section-eyebrow">Résultats</div>
        <h2 className="section-title">Un impact mesurable</h2>
        <p style={{ color: '#555', lineHeight: 1.75, marginBottom: '32px', maxWidth: '600px' }}>
          La première cohorte a dépassé les objectifs initiaux. 85% des apprenants ont décroché un emploi ou un contrat freelance dans les 3 mois suivant la fin du programme.
        </p>
        <div className="ada-results-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
          {outcomes.map((o, i) => (
            <div key={i} style={{ background: '#f8faf8', border: '0.5px solid #e8e8e8', borderRadius: '14px', padding: '28px 24px' }}>
              <div style={{ fontFamily: "'Sora',sans-serif", fontSize: '40px', fontWeight: 800, background: 'var(--grad)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', lineHeight: 1, marginBottom: '8px' }}>{o.num}</div>
              <div style={{ fontFamily: "'Sora',sans-serif", fontSize: '15px', fontWeight: 700, color: '#111', marginBottom: '4px' }}>{o.label}</div>
              <div style={{ fontSize: '14px', color: '#888' }}>{o.sub}</div>
            </div>
          ))}
        </div>
      </section>

      {/* GALERIE — Filmstrip 3 cartes */}
      <section className="section section-alt">
        <div className="section-eyebrow">Moments du programme</div>
        <h2 className="section-title">En images</h2>
        <div className="ada-fs">
          <div className="ada-fs__stage">
            {/* Gauche — image précédente estompée, cliquable */}
            <div className="ada-fs__side" onClick={goPrev}>
              <img src={adaImages[prevIdx]} alt="" />
            </div>
            {/* Centre — image active, animation au changement */}
            <div key={slide} className="ada-fs__center">
              <img src={adaImages[slide]} alt={`Atos Digital Academy — moment ${slide + 1}`} />
            </div>
            {/* Droite — image suivante estompée, cliquable */}
            <div className="ada-fs__side" onClick={goNext}>
              <img src={adaImages[nextIdx]} alt="" />
            </div>
          </div>
          <div className="ada-fs__controls">
            <button className="ada-fs__arrow" onClick={goPrev} aria-label="Photo précédente">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <div className="ada-fs__dots">
              {adaImages.map((_, i) => (
                <button key={i} className={`ada-fs__dot${i === slide ? ' active' : ''}`} onClick={() => setSlide(i)} aria-label={`Photo ${i + 1}`} />
              ))}
            </div>
            <button className="ada-fs__arrow" onClick={goNext} aria-label="Photo suivante">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
          </div>
          <div className="ada-fs__counter">{slide + 1} / {total}</div>
        </div>
      </section>

      {/* CTA */}
      <section className="ada-cta-section" style={{ padding: '72px 40px', background: 'linear-gradient(135deg, #0d1f14 0%, #1a3a22 55%, #0d1f14 100%)', textAlign: 'center' }}>
        <div style={{ position: 'relative', zIndex: 1, maxWidth: '560px', margin: '0 auto' }}>
          <div className="section-eyebrow" style={{ color: '#8BC53F', borderColor: 'rgba(139,197,63,.3)', background: 'rgba(139,197,63,.1)', display: 'inline-flex' }}>
            Vous avez un projet similaire ?
          </div>
          <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: '34px', fontWeight: 800, color: '#fff', letterSpacing: '-0.6px', lineHeight: 1.2, marginBottom: '16px', marginTop: '20px' }}>
            Reproduisons ce modèle<br /><span style={{ background: 'var(--grad)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>pour votre organisation</span>
          </h2>
          <p style={{ fontSize: '15px', color: 'rgba(255,255,255,.5)', marginBottom: '32px', lineHeight: 1.65 }}>
            TTA co-conçoit et opère des programmes sur-mesure pour les entreprises, institutions et bailleurs. Contactez-nous pour démarrer.
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" className="btn-primary" style={{ fontSize: '14px', padding: '14px 28px' }}>
              Nous contacter →
            </Link>
            <Link to="/bailleurs" style={{ fontFamily: "'Sora',sans-serif", fontSize: '14px', fontWeight: 500, padding: '14px 22px', background: 'transparent', border: '1px solid rgba(255,255,255,.2)', color: 'rgba(255,255,255,.75)', borderRadius: '9px', textDecoration: 'none' }}>
              Espace bailleurs
            </Link>
          </div>
        </div>
      </section>

    </main>
  );
}
